import api from '../../infra/api';

class Fabricantes {
  async Listar(watchTipoEquipamento) {
    const tipoFilter = watchTipoEquipamento?.value;

    const filtros = [
      { property: "Ativo", operator: "in", value: [1], and: false }
    ];

    if (tipoFilter) {
      filtros.push({
        property: "Tipo",
        operator: "in",
        value: [tipoFilter],
        and: true
      });
    }

    const response = await api({
      method: "GET",
      url: `api/v1/Fabricantes?page=1&start=0&limit=999&fields=["Id","CodigoAneel","NomeFabricante","Tipo","Ativo"]&filter=${encodeURIComponent(JSON.stringify(filtros))}`
    });

    return response.data;
  }
}

export default new Fabricantes;
